module.exports = __webpack_public_path__ + "static/media/AU-SYDNEY.868cf01b.png";